import { ActionTypes, HeartbeatSettingActions } from './heartbeat-settings.actions';
import { HeartbeatSettingState } from './heartbeat-settings.model';

export const heartbeatSettingState: HeartbeatSettingState = {
  tableDataLoading: false,
  tableDataLoaded: false,
  tableData: [],
  tablePageInfo: {
    page: 1,
    pageCount: 0,
    total: 0,
  },
  getHeartbeatSettingLoading: false,
  getHeartbeatSettingLoaded: false,
  heartbeatSetting: null,
  addHeartbeatSettingLoading: false,
  addHeartbeatSettingLoaded: false,
  editHeartbeatSettingLoading: false,
  editHeartbeatSettingLoaded: false,
  deleteHeartbeatSettingsLoading: false,
  deleteHeartbeatSettingsLoaded: false,
  mailGroupsDataLoading: false,
  mailGroupsDataLoaded: false,
  mailGroupsData: [],
  mailTemplatesDataLoading: false,
  mailTemplatesDataLoaded: false,
  mailTemplatesData: [],
};

export function heartbeatSettingReducer(
  state: HeartbeatSettingState = heartbeatSettingState,
  action: HeartbeatSettingActions,
): HeartbeatSettingState {
  switch (action.type) {
    case ActionTypes.HEARTBEAT_SETTINGS_DATA_LOADING:
      return {
        ...state,
        tableDataLoading: true,
        tableDataLoaded: false,
      };
    case ActionTypes.HEARTBEAT_SETTINGS_DATA_LOADED:
      return {
        ...state,
        tableData: action.payload.data,
        tablePageInfo: {
          page: action.payload.page,
          pageCount: action.payload.pageCount,
          total: action.payload.total,
        },
        tableDataLoading: false,
        tableDataLoaded: true,
      };
    case ActionTypes.GET_HEARTBEAT_SETTING:
      return {
        ...state,
        getHeartbeatSettingLoading: true,
        getHeartbeatSettingLoaded: false,
      };
    case ActionTypes.GET_HEARTBEAT_SETTING_COMPLETED:
      return {
        ...state,
        heartbeatSetting: action.payload.data,
        getHeartbeatSettingLoading: false,
        getHeartbeatSettingLoaded: true,
      };
    case ActionTypes.ADD_HEARTBEAT_SETTING:
      return {
        ...state,
        addHeartbeatSettingLoading: true,
        addHeartbeatSettingLoaded: false,
      };
    case ActionTypes.ADD_HEARTBEAT_SETTING_COMPLETED:
      return {
        ...state,
        addHeartbeatSettingLoading: false,
        addHeartbeatSettingLoaded: true,
      };
    case ActionTypes.EDIT_HEARTBEAT_SETTING:
      return {
        ...state,
        editHeartbeatSettingLoading: true,
        editHeartbeatSettingLoaded: false,
      };
    case ActionTypes.EDIT_HEARTBEAT_SETTING_COMPLETED:
      return {
        ...state,
        editHeartbeatSettingLoading: false,
        editHeartbeatSettingLoaded: true,
      };
    case ActionTypes.DELETE_HEARTBEAT_SETTINGS:
      return {
        ...state,
        deleteHeartbeatSettingsLoading: true,
        deleteHeartbeatSettingsLoaded: false,
      };
    case ActionTypes.DELETE_HEARTBEAT_SETTINGS_COMPLETED:
      return {
        ...state,
        deleteHeartbeatSettingsLoading: false,
        deleteHeartbeatSettingsLoaded: true,
      };
    case ActionTypes.MAIL_GROUPS_DATA_LOADING:
      return {
        ...state,
        mailGroupsDataLoading: true,
        mailGroupsDataLoaded: false,
      };
    case ActionTypes.MAIL_GROUPS_DATA_COMPLETED:
      return {
        ...state,
        mailGroupsData: action.payload.data,
        mailGroupsDataLoading: false,
        mailGroupsDataLoaded: true,
      };
    case ActionTypes.MAIL_TEMPLATES_DATA_LOADING:
      return {
        ...state,
        mailTemplatesDataLoading: true,
        mailTemplatesDataLoaded: false,
      };
    case ActionTypes.MAIL_TEMPLATES_DATA_COMPLETED:
      return {
        ...state,
        mailTemplatesData: action.payload.data,
        mailTemplatesDataLoading: false,
        mailTemplatesDataLoaded: true,
      };
    case ActionTypes.FETCH_ERROR:
      return {
        ...state,
      };
    default:
      return state;
  }
}
